import {h, render} from 'preact';
import {Fragment} from 'react';
import DashboardComponent from './DashboardComponent';
import Masonry from 'react-masonry-component';

const finderPage = document.getElementById('philanthropy-giving-dashboard');

const masonryOptions = {
  fillWidth: true,
  gutter: '.gutter-sizer',
};

const getDashboardPayload = (json) => {
  if (json && Array.isArray(json.componentData)) {
    return json;
  }
  if (json && json.data && Array.isArray(json.data.componentData)) {
    return json.data;
  }
  return null;
};

const processComponents = (payload) => {
  const rawComponents = payload.componentData;
  return rawComponents.map((component, idx) => {
    return Object.assign({}, {
      id: component.componentId,
      data: component.reportResult,
      meta: payload.dashboardMetadata.components[idx],
      layout: payload.dashboardMetadata.layout.components[idx],
    });
  }).sort((a, b) => {
    const aSortWeight = a.layout.column + a.layout.row + a.layout.colspan + a.layout.rowspan;
    const bSortWeight = b.layout.column + b.layout.row + b.layout.colspan + b.layout.rowspan;
    return aSortWeight - bSortWeight;
  });
};

const showDashboardError = () => {
  if (!finderPage) {
    return;
  }
  finderPage.classList.remove('finder-spinner');
  finderPage.innerHTML = '<p class="dashboard-error">Giving totals are still loading. Please refresh the page in a moment.</p>';
};

const PhilanthropyDashboard = (props) => {
  return (
    <>
      {props.payload.dashboardMetadata.name &&
        <h2 class="dashboard-name">{props.payload.dashboardMetadata.name}</h2>
      }
      <Masonry
        className="dahsboard-components"
        elementType={'div'}
        options={masonryOptions}
      >
        {props.components.map((component, idx) => {
          if (!component.data) {
            return '';
          }

          return <DashboardComponent key={idx} component={component} />;
        })}
        <div class="gutter-sizer"></div>
      </Masonry>
    </>
  );
};

if (finderPage) {
  (async () => {
    try {
      const url = new URL(window.location.protocol + '//' + window.location.host + jsonUrl);
      url.searchParams.set('api_endpoint', apiEndpoint);
      const response = await fetch(url.href);
      if (!response.ok) {
        throw new Error('Dashboard request failed');
      }

      const json = await response.json();
      const payload = getDashboardPayload(json);
      if (!payload) {
        throw new Error('Dashboard payload missing');
      }

      const components = processComponents(payload);

      finderPage.innerHTML = '';
      finderPage.classList.remove('finder-spinner');
      render(<PhilanthropyDashboard payload={payload} components={components} />, finderPage);
    }
    catch (error) {
      showDashboardError();
    }
  })();
}
